module.exports = __webpack_public_path__ + "media/images/hero_images/brand-1200-6b22a7eda1ac28797fbbbb0ee7a45ddb.jpg";